// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--shadow-picture:0px 1px 4px 0px rgba(51,51,51,0.1);--shadow-picture-dark:0px 1px 4px 0px rgba(51,51,51,0.15);--shadow-regular:0px 2px 8px 0px rgba(51,51,51,0.05);--shadow-regular-dark:0px 4px 16px 0px rgba(51,51,51,0.1);--shadow-sticky-bottom:0px -2px 8px 0px rgba(51,51,51,0.05)};", ""]);
// Exports
module.exports = exports;
